import { NgModule } from '@angular/core';
import { NgbdSortableHeader } from './sortable/sortable.directive';

@NgModule({
  imports: [],
  declarations: [NgbdSortableHeader],
  exports: [NgbdSortableHeader],
})
export class DirectivesModule {}
